module.exports = __webpack_public_path__ + "img/options_icon.1d1b09b1.svg";